'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactShare = require('react-share');
var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _ShareActicleButtons = require('./ShareActicleButtons.scss');var styles = _interopRequireWildcard(_ShareActicleButtons);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
var WhatsappIcon = (0, _reactShare.generateShareIcon)('whatsapp');
var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
var LinkedinIcon = (0, _reactShare.generateShareIcon)('linkedin');var
FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton,LinkedinShareButton = _reactShare.ShareButtons.LinkedinShareButton;var

ShareArticleButtons = function (_Component) {_inherits(ShareArticleButtons, _Component);function ShareArticleButtons() {var _temp, _this, _ret;_classCallCheck(this, ShareArticleButtons);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      linkCopied: false }, _this.


    handleCopyLink = function () {
      _this.setState({ linkCopied: true });
    }, _this.

    renderShareEmail = function (sharingUrl, sharingTitle) {
      var link = 'mailto:?subject=' + sharingTitle + '&body=' + sharingTitle + ' ' + sharingUrl;
      return (
        _react2.default.createElement('a', { href: link, className: styles.shareRow },
          _react2.default.createElement('div', { className: styles.iconWrapper },
            _react2.default.createElement('span', { className: 'icon icon-mailIcon' }))));



    }, _this.

    renderShouldCopyButton = function () {return (
        _react2.default.createElement('div', { className: styles.copyLinkWrap },
          _react2.default.createElement('span', { className: 'icon icon-copy-link' },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' }))));}, _this.




    renderCopiedButton = function () {return (
        _react2.default.createElement('span', { className: 'icon icon-circled-check' },
          _react2.default.createElement('span', { className: 'path1' }),
          _react2.default.createElement('span', { className: 'path2' })));}, _this.



    renderShareIcon = function () {return (
        _react2.default.createElement('div', { className: styles.shareTitle },
          _react2.default.createElement('span', null, _this.props.translate('propertyDetails', 'shareTitle'), ':')));}, _temp), _possibleConstructorReturn(_this, _ret);}ShareArticleButtons.prototype.



  render = function render() {var _props =
    this.props,_props$sharingData = _props.sharingData,sharingUrl = _props$sharingData.sharingUrl,sharingTitle = _props$sharingData.sharingTitle,isMobile = _props.isMobile;
    var protocol = sharingUrl.includes('://') ? '' : 'https://';
    var shareText = encodeURIComponent(sharingTitle) + ' ' + protocol + sharingUrl;
    var whatsappLink = isMobile ? 'whatsapp://send?text=' +
    shareText : 'https://api.whatsapp.com/send?text=' +
    shareText;

    var iconSize = 24;

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.wrapper, styles[this.props.className]) },

        _react2.default.createElement('div', null,
          this.renderShareIcon(),
          _react2.default.createElement('div', { className: styles.shareRow },
            _react2.default.createElement(FacebookShareButton, {
                url: protocol + sharingUrl },

              _react2.default.createElement('div', { className: styles.iconWrapper },
                _react2.default.createElement(FacebookIcon, { size: iconSize, round: true })))),



          _react2.default.createElement('a', {
              className: styles.shareRow,
              href: whatsappLink,
              target: '_blank',
              'data-action': 'share/whatsapp/share' },

            _react2.default.createElement('div', { className: styles.iconWrapper },
              _react2.default.createElement(WhatsappIcon, { size: iconSize, round: true }))),


          _react2.default.createElement('div', { className: styles.shareRow },
            _react2.default.createElement(TwitterShareButton, {
                url: protocol + sharingUrl,
                title: sharingTitle },

              _react2.default.createElement('div', { className: styles.iconWrapper },
                _react2.default.createElement(TwitterIcon, { size: iconSize, round: true })))),



          _react2.default.createElement('div', { className: styles.shareRow },
            _react2.default.createElement(LinkedinShareButton, {
                url: protocol + sharingUrl,
                title: sharingTitle },

              _react2.default.createElement('div', { className: styles.iconWrapper },
                _react2.default.createElement(LinkedinIcon, { size: iconSize, round: true })))),




          _react2.default.createElement(_reactCopyToClipboard.CopyToClipboard, {
              text: sharingUrl && sharingUrl.replace(/www./g, ''),
              onCopy: this.handleCopyLink },

            _react2.default.createElement('div', { className: styles.shareRow },
              _react2.default.createElement('div', { className: styles.iconWrapper },
                this.state.linkCopied ? this.renderCopiedButton() : this.renderShouldCopyButton()))),




          this.renderShareEmail('' + protocol + sharingUrl, sharingTitle))));



  };return ShareArticleButtons;}(_react.Component);exports.default = ShareArticleButtons;


ShareArticleButtons.propTypes = {
  shareProperties: _propTypes2.default.object,
  className: _propTypes2.default.string,
  shareTitle: _propTypes2.default.string,
  copyLinkTitle: _propTypes2.default.string,
  sharingData: _propTypes2.default.object,
  hideTooltip: _propTypes2.default.func,
  isTooltipShown: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareArticleButtons/ShareArticleButtons.js
// module id = 2880
// module chunks = 0